import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const V1 = '/v1';
const APP_CATEGORY_PATH = '/app-category';

const FetchAppCategory = new ReduxAsyncAction('FETCH_APP_CATEGORY');
FetchAppCategory.registerRequest(async () => {
  const URI = `${V1}${APP_CATEGORY_PATH}`;
  const appCategory = await dash_api.get(URI);
  return appCategory;
});

export const FETCH_APP_CATEGORY = FetchAppCategory.constants;
export const fetchAppCategory = FetchAppCategory.request;

export default {
  fetchAppCategory,
};
